import { mapState } from 'vuex'

export const globalFunctions = {
    computed:{
        ...mapState(['url'])
    },
    methods: {

        //Mensaje Ok
        msjOk(msg = 'Informacion Actualizada'){
            this.$swal.fire({
                position: 'top-end',
                icon: 'success',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            })
        },

        msjOk2(msg = 'Informacion Actualizada'){
            this.$swal.fire({
                position: 'top-end',
                icon: 'success',
                title: msg,
                showConfirmButton: false,
                timer: 2500
            })
        },

        loadingModal(){
            this.$swal.showLoading();
        },

        closeLoadingModal(){
            this.$swal.close();
        },

        descargarFile(file){
            this.axios.get(this.url + "uploads/" + file, {responseType: 'arraybuffer'}).then((responce) => {
                let blob = new Blob([responce.data], {type:'application/*'})
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = file
                link.click();
            });
        },

        //Mensaje en caso de error
        msjError(msg){
            this.$swal.fire({
            icon: 'error',
            text: msg,
            })
        },

        //Filtros
        moneda(value) {
            let val = (value/1).toFixed(2).replace(',', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        moneda(value) {
            let val = (value/1).toFixed(2).replace(',', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        fechaFormat(date){
            let anio = date.substr(0,4);
            let mes = date.substr(5,2);
            let dia = date.substr(8,2);

            let newDate = dia + '/' + mes + '/' + anio;
            return newDate;
        },

        addZeros(num){
            let i = true;

            while(i==true){
              if(num.length < 5){
                  num = '0' + num;
              }else{
                  i=false;
              }
            }
            return num;
        },

        //Ruta del folder de fotos + nombre de archivo
        getUrl(ruta){
            let value = this.url + 'avatars/' + ruta;
            return value;
        },

        //Api de banderas
        getBandera(pais){
            let value = this.url + 'banderas/' + pais + '.png';
            return value;
        },

        //Regresa un int
        makeNumber(num){
            let i = Number(num);
            return i;
        },

        addFiveDaysToday() {

            var date = new Date();
            date.setDate(date.getDate() + 6);

            var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            var maxDate = [year, month, day].join('-');

            return maxDate;

        },

        addDaysToday() {

            var date = new Date();
            date.setDate(date.getDate() + 16);

            var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            var maxDate = [year, month, day].join('-');

            return maxDate;

        },

        checkUser(){
            const token = localStorage.token;
            const UserName = localStorage.userID;
            const tabla = localStorage.tabla;
            let sesion = true;

            let data = {
                token: token,
                user: UserName,
                tabla: tabla
            }

            this.axios.post(this.url + "checkToken.php", data).then((responce) => {
              if(responce.data.res != '200'){
                sesion = false;
                this.$router.push('/');
              }else{
                localStorage.pk = responce.data.pk;
              }
            });

            return sesion;
        },

        sendEmail(flag, email = '', param1 = 0, param2 = 0, param3 = 0, param4 = 0){

            let data = {
                flag,
                email,
                param1,
                param2,
                param3,
                param4
            };

            data.flag = flag;

            this.axios.post(this.url + 'sendEmail.php', data).then((responce) =>{
                
            })
        },

        enviarCorreo(idTemplate, subject, idProyecto, idGeneric = null) {

            let data = {
                template: idTemplate,
                subject,
                idProyecto,
                idGeneric
            }

            this.axios.post(this.url + 'sendEmailAviso.php', data).then((response) =>{
               console.log(response.data);
            })

        }
    },
}



// WEBPACK FOOTER //
// ./src/hooks/globalFunctions.js